// ============================================
// 📋 FORMULÁRIO MULTI-IDS - form-multi-ids.js
// Suporta múltiplos formulários com IDs diferentes
// Form ID: 492743
// ============================================

(function initMultiForm() {
  console.log("🔵 [FORM MULTI] Inicializando sistema multi-formulários");
  
  const COOKIE_NAME = "utm_campaign";
  const COOKIE_DAYS = 30;
  const FORM_ID = "492743";
  
  // ==========================================
  // 🎯 ADICIONE TODOS OS IDs DE CONTAINERS AQUI
  // ==========================================
  const CONTAINER_IDS = [
    "#AeDhqbnozeTFWTmE5V__forms_inline_WtWTQP",  // Form Home
    "#AQ2xMWlg2bWMzcThBM__forms_inline_hWn9y8",  // Form agendamento
    "#AaW12OWhtcjBYMmY0T__forms_inline_qiiVkW",  // Form pagina de produto vestidos
    "#AbUljVW9GVStud1RBU__forms_inline_YEB8JV"  // Form pagina de produto acessorios

  ];

  // Controle de instâncias processadas
  const processedForms = new WeakSet();

  // ==========================================
  // 🔧 FUNÇÕES AUXILIARES - UTM
  // ==========================================
  function setCookie(name, value, days) {
    if (!value) return;
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
    console.log("🔵 [FORM MULTI] Cookie UTM salvo:", value);
  }

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    const cookie = cookies.find(c => c.startsWith(name + "="));
    return cookie ? decodeURIComponent(cookie.split("=")[1]) : "";
  }

  function getUTMValue() {
    const params = new URLSearchParams(window.location.search);
    const utmFromUrl = params.get("utm_campaign");
    
    let utmValue = "";
    if (utmFromUrl) {
      utmValue = utmFromUrl;
      setCookie(COOKIE_NAME, utmFromUrl, COOKIE_DAYS);
    } else {
      utmValue = getCookie(COOKIE_NAME);
    }
    
    return utmValue;
  }

  // ==========================================
  // 🎨 APLICAR ESTILOS NO FORMULÁRIO
  // ==========================================
  function applyFormStyles(targetForm, appEmbed, utmField, containerId) {
    const isMobile = window.innerWidth <= 768;
    let formStarted = false;
    const utmValue = getUTMValue();

    console.log("✅ [FORM MULTI] Aplicando estilos no formulário");
    console.log("   📦 Container ID:", containerId);
    console.log("   📍 Página:", window.location.pathname);

    // ==========================================
    // 🏷️ UTM - CAMPO OCULTO
    // ==========================================
    if (utmValue && utmField) {
      utmField.value = utmValue;
      utmField.dispatchEvent(new Event("input", { bubbles: true }));
      utmField.dispatchEvent(new Event("change", { bubbles: true }));
      console.log("✅ [FORM MULTI] UTM aplicado:", utmValue);
    }

    // Oculta o campo UTM completamente
    if (utmField) {
      const utmWrapper = utmField.closest('[data-testid="form-field-wrapper"]');
      if (utmWrapper) {
        utmWrapper.style.cssText = "display: none !important; visibility: hidden !important; height: 0 !important; margin: 0 !important; padding: 0 !important;";
      }
      
      utmField.style.cssText = "display: none !important; visibility: hidden !important;";
      
      const utmLabel = appEmbed.shadowRoot.querySelector('label[for*="utm"]');
      if (utmLabel) {
        utmLabel.style.cssText = "display: none !important; visibility: hidden !important;";
      }
    }

    // ==========================================
    // 🎨 WRAPPER - ESTILO ROXO/AZUL
    // ==========================================
    const formWrapper = appEmbed.shadowRoot.querySelector('section[data-sizing="form-wrapper"]');
    if (formWrapper) {
      formWrapper.style.cssText += `
        padding: ${isMobile ? '0px' : '35px'} !important;
        max-width: 800px !important;
        margin: 0px auto !important;
      `;
    }

    // ==========================================
    // 📝 INPUTS - EVENTOS E ESTILOS
    // ==========================================
    const allInputs = targetForm.querySelectorAll('input');
    console.log(`🔵 [FORM MULTI] ${allInputs.length} inputs encontrados`);

    allInputs.forEach(input => {
      // Evento de início de preenchimento
      input.addEventListener('focus', () => {
        if (!formStarted) {
          formStarted = true;
          
          console.log("🎯 [FORM MULTI] ========================================");
          console.log("🎯 [FORM MULTI] USUÁRIO COMEÇOU A PREENCHER!");
          console.log("🎯 [FORM MULTI] Form ID: 492743");
          console.log("🎯 [FORM MULTI] Container:", containerId);
          console.log("🎯 [FORM MULTI] Página:", window.location.pathname);
          console.log("🎯 [FORM MULTI] ========================================");

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'initiate_form',
            'form_id': FORM_ID,
            'form_type': 'standard',
            'container_id': containerId,
            'page_url': window.location.href,
            'timestamp': new Date().getTime()
          });
        }
      }, { once: true });

      // Estilos dos inputs - ROXO/AZUL
      input.style.cssText += `
        color: #A6A6A6 !important;
        background: transparent !important;
        font-size: 15px !important;
        border: 1px solid #959595 !important;
        border-radius: 10px !important;
        box-sizing: border-box !important;
        font-family: Montserrat !important;
        transition: 0.3s !important;
      `;

      // Efeito hover nos inputs
      input.addEventListener('focus', () => {
        input.style.borderColor = "#5e35b1 !important";
        input.style.boxShadow = "0 0 0 3px rgba(94, 53, 177, 0.1) !important";
      });

      input.addEventListener('blur', () => {
        input.style.borderColor = "#7e57c2 !important";
        input.style.boxShadow = "none !important";
      });
    });

    // ==========================================
    // 🏷️ LABELS - ESTILOS
    // ==========================================
    const allLabels = targetForm.querySelectorAll('label');
    allLabels.forEach(label => {
      // estilo padrão para todas
      label.style.cssText += `
        font-family: Montserrat !important;
        font-size: 14px !important;
        color: #A6A6A6 !important;
        font-weight: 500 !important;
      `;

      // estilo adicional só para phone_number
        if (label.getAttribute('for') === 'label-phone_number') {
          console.log("passou")
          label.style.setProperty('transform', 'translateY(-10px)', 'important');
        }
    })

    // ==========================================
    // 🚀 BOTÃO DE ENVIO
    // ==========================================
    const submitBtn = targetForm.querySelector('button[data-testid="btn-form-submit"]');
    if (submitBtn) {
      submitBtn.style.cssText += `
        width: ${isMobile ? '100%' : '30%'} !important;
        transform: translateY(0px);
        background: transparent;
        border-radius: 0px;
        width: 20% !important;
        font-family: Montserrat !important;
        border: 2px solid rgb(0, 0, 0) !important;
        color: rgb(0, 0, 0) !important;
        text-transform: uppercase !important;
        font-weight: bold !important;
        font-size: 16px !important;
        cursor: pointer !important;
        display: block !important;
        text-align: center !important;
        margin: 0px auto !important;
        padding: 16px !important;
        transition: 0.3s !important;
      `;

      // Hover effect
      submitBtn.addEventListener('mouseenter', () => {
        submitBtn.style.transform = "translateY(-2px)";
      });

      submitBtn.addEventListener('mouseleave', () => {
        submitBtn.style.transform = "translateY(0)";
      });

      // Evento de submit
      submitBtn.addEventListener("click", () => {
        const nome = targetForm.querySelector('#first_name')?.value || '';
        const email = targetForm.querySelector('#email')?.value || '';
        const whatsapp = targetForm.querySelector('#phone_number')?.value || '';
        const local = targetForm.querySelector('#custom\\#local_do_casamento')?.value || '';
        const dia = targetForm.querySelector('input[aria-labelledby="label-DD"]')?.value;
        const mes = targetForm.querySelector('input[aria-labelledby="label-MM"]')?.value;
        const ano = targetForm.querySelector('input[aria-labelledby="label-YYYY"]')?.value;

        const dataCasamento = (dia && mes && ano) ? `${dia}/${mes}/${ano}` : "Não informado";

        console.log("🚀 [FORM MULTI] ========================================");
        console.log("🚀 [FORM MULTI] FORMULÁRIO ENVIADO!");
        console.log("🚀 [FORM MULTI] Form ID: 492743");
        console.log("🚀 [FORM MULTI] Container:", containerId);
        console.log("🚀 [FORM MULTI] Página:", window.location.pathname);
        console.log("🚀 [FORM MULTI] ========================================");
        console.log("🚀 [FORM MULTI] Dados capturados:");
        console.log("   📝 Nome:", nome);
        console.log("   📧 Email:", email);
        console.log("   📱 WhatsApp:", whatsapp);
        console.log("   📅 Data Casamento:", dataCasamento);
        console.log("   📍 Local:", local);
        console.log("   🏷️ UTM:", utmValue);
        console.log("🚀 [FORM MULTI] ========================================");

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'lead_form_submit',
          'form_id': FORM_ID,
          'container_id': containerId,
          'page_url': window.location.href,
          'form_data': {
            'nome': nome,
            'email': email,
            'whatsapp': whatsapp,
            'data_casamento': dataCasamento,
            'local_casamento': local,
            'utm_campaign': utmValue
          }
        });
      });
    }

    // ==========================================
    // 🌍 BOTÃO DE PAÍS (se existir)
    // ==========================================
    const countryBtn = appEmbed.shadowRoot.querySelector('button[class*="selectToggle"]');
    if (countryBtn) {
      countryBtn.style.cssText += `
        background: transparent;
        border: 1px solid #A6A6A6 !important;
        border-radius: 10px !important;
        height: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin-right: 5px !important;
        max-height: 51px !important;
      `;
    }

    // Marca como processado usando WeakSet
    processedForms.add(targetForm);
    console.log("✅ [FORM MULTI] Formulário configurado com sucesso!");
  }

  // ==========================================
  // 🔍 PROCESSAR TODOS OS FORMULÁRIOS
  // ==========================================
  const processAllForms = () => {
    let formsFound = 0;
    let formsProcessed = 0;

    CONTAINER_IDS.forEach(containerId => {
      const container = document.querySelector(containerId);

      if (!container) {
        return;
      }

      const appEmbed = container.querySelector('#app-embed');
      
      if (!appEmbed || !appEmbed.shadowRoot) {
        return;
      }

      const targetForm = appEmbed.shadowRoot.querySelector('form');
      const utmField = appEmbed.shadowRoot.querySelector('#custom\\#utm');

      if (!targetForm) {
        return;
      }

      formsFound++;

      // Verifica se já foi processado usando WeakSet
      if (processedForms.has(targetForm)) {
        return;
      }

      // Aplica os estilos
      applyFormStyles(targetForm, appEmbed, utmField, containerId);
      formsProcessed++;
    });

    if (formsProcessed > 0) {
      console.log(`✅ [FORM MULTI] ${formsProcessed} formulário(s) processado(s) nesta execução`);
    }

    return formsProcessed > 0;
  };

  // ==========================================
  // 👀 OBSERVER PERMANENTE - MONITORA DOM
  // ==========================================
  const observer = new MutationObserver(() => {
    processAllForms();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // ==========================================
  // 🔄 LISTENER PARA MUDANÇAS DE PÁGINA
  // ==========================================
  
  // Para SPAs (Single Page Applications)
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      console.log("🔄 [FORM MULTI] Mudança de página detectada:", url);
      
      setTimeout(() => processAllForms(), 500);
      setTimeout(() => processAllForms(), 1000);
      setTimeout(() => processAllForms(), 2000);
    }
  }).observe(document, { subtree: true, childList: true });

  // Para navegação com History API
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function() {
    originalPushState.apply(this, arguments);
    console.log("🔄 [FORM MULTI] PushState detectado");
    setTimeout(() => processAllForms(), 500);
    setTimeout(() => processAllForms(), 1000);
  };

  history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    console.log("🔄 [FORM MULTI] ReplaceState detectado");
    setTimeout(() => processAllForms(), 500);
  };

  // Listener para evento popstate (botão voltar/avançar)
  window.addEventListener('popstate', () => {
    console.log("🔄 [FORM MULTI] Popstate detectado (navegação voltar/avançar)");
    setTimeout(() => processAllForms(), 500);
    setTimeout(() => processAllForms(), 1000);
  });

  // ==========================================
  // 📱 LISTENER PARA RESIZE (Mobile/Desktop)
  // ==========================================
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      console.log("📱 [FORM MULTI] Resize detectado, reprocessando formulários");
      processAllForms();
    }, 250);
  });

  // ==========================================
  // 🚀 INICIALIZAÇÃO
  // ==========================================
  
  // Tenta processar imediatamente
  processAllForms();
  
  // Tenta novamente após delays
  setTimeout(() => processAllForms(), 500);
  setTimeout(() => processAllForms(), 1000);
  setTimeout(() => processAllForms(), 2000);
  setTimeout(() => processAllForms(), 3000);

  console.log("✅ [FORM MULTI] Sistema multi-formulários ativado!");
  console.log("📦 [FORM MULTI] Monitorando", CONTAINER_IDS.length, "container(s):");
  CONTAINER_IDS.forEach((id, index) => {
    console.log(`   ${index + 1}. ${id}`);
  });
  console.log("📍 [FORM MULTI] Página inicial:", window.location.pathname);

  // Expõe função global para debug/teste manual
  window.reprocessAllForms = () => {
    console.log("🔧 [FORM MULTI] Reprocessamento manual solicitado");
    processAllForms();
  };

  // Função para adicionar novo container ID dinamicamente
  window.addFormContainer = (newContainerId) => {
    if (!CONTAINER_IDS.includes(newContainerId)) {
      CONTAINER_IDS.push(newContainerId);
      console.log("➕ [FORM MULTI] Novo container adicionado:", newContainerId);
      processAllForms();
    } else {
      console.log("⚠️ [FORM MULTI] Container já existe na lista:", newContainerId);
    }
  };

})();
